import { Component, SecurityContext, NgZone, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { InMemoryStorageService } from '../storage/in-memory-storage.service';
import { TokenResponse } from './token-response';

@Component({
  selector: 'app-token-renew',
  template: `<div class="hide-me" id="divRenewToken">
                <iframe (load)="loadIframe()" id="tokenIframe">
                </iframe>
              </div>`,
  styles: ['.hide-me { display: none; }']
})

export class TokenRenewComponent implements OnInit {

  constructor(
    private zone: NgZone, private _storage: InMemoryStorageService, private http: HttpClient) {

    window['tokenRenewComponent'] = {
      zone: this.zone,
      componentFn: () => this.renewTokenCallback(),
      component: this,
    };
  }

  //timeOut = 30000;//30 sec
  //timeOut = 120000;//2 min
  //timeOut = 300000;//5 min
  timeOut = 720000;//12 min

  //call renewToken on load
  ngOnInit() {
    this.renewToken();
  }


  renewTokenCallback() {

  }


  loadIframe() {
    //access iframe and hidden field
    var iframe = document.getElementById("tokenIframe") as HTMLIFrameElement;
    var hiddenToken = iframe.contentWindow.document.getElementById('newToken') as HTMLInputElement;
    var resp = null;
    try {
      resp = JSON.parse(hiddenToken.value);
      var token = resp.access_token;
      console.log("expires_in - " + (resp.expires_in));
      //this.timeOut = (resp.expires_in * 1000) * (3/4);//multiply by 1000 to set time to timeOut object 
      this._storage.setItem("accessToken", token);
    }
    catch (e) {

    }
  }

  renewToken() {
    this.http.get<TokenResponse>("/token/renew").subscribe(response => {
      //access iframe element
      var iframe = document.getElementById("tokenIframe") as HTMLIFrameElement;
      iframe.setAttribute("src", response.renewUrl);

      //set func after time
      setTimeout(() => { this.renewToken(); }, this.timeOut);

    }, (errorResponse) => {
      //set func after time
      setTimeout(() => { this.renewToken(); }, this.timeOut);
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/token/renew-token.component.ts